import { render, staticRenderFns } from "./ChangeSiteName.vue?vue&type=template&id=70a084ee"
import script from "./ChangeSiteName.vue?vue&type=script&lang=js"
export * from "./ChangeSiteName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports